import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    getUsers(type) {
        return API.get(`users/type/${type}`).then((res) => {
            const result = res.data;
            return result;
        });
    },
    addUser(formdata) {
        return API.post('adduser', httpBuildQuery(formdata)).then(res => (res.data));
    },
    editUser(formdata) {
        return API.post('edituser', httpBuildQuery(formdata)).then(res => (res.data));
    },
    getUserInfo(id) {
        return API.get(`userinfo/id/${id}`).then(res => (res.data));
    },
    updateUserStatus(id, status) {
        return API.get(`updateUserStatus/id/${id}/status/${status}`).then((res) => {
            const result = res.data;
            return result;
        });
    },
};
